import { MrbBaseRouteStore } from "mrb/core";
import { NakiNigunImportService } from "common/services";

class NakiNigunImportBatchListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(NakiNigunImportService);
    }

    async findBatches(params) {
        const response = await this.service.find(params);
        return response.data;
    }

    async refresh() {
        const response = await this.service.refresh();
        return response.data;
    }

    async discardBatch(id) {
        const response = await this.service.discardBatch(id);
        return response.data;
    }
}

export default NakiNigunImportBatchListRouteStore;
